import React, {useState, useEffect} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities"; 
import { FallingLines } from 'react-loader-spinner'
import { paymentAssoPendingDet } from "../../../apis/urls";


const AssociationMoreDashboard = () => {


    useEffect( ()=> {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        ApproveListing();
    },[])

    let navigate = useNavigate()


    let role = localStorage.getItem('userrole');

    // console.log("role", role)




    const [result, setResult] = useState([]); 
    const [resultAss, setResultAss] = useState(); 
    const [loader, setLoader] = useState(true);  
  
    const {id} = useParams();

    let token = "Bearer "+localStorage.getItem('token');

    const ApproveListing = () => {
         
        const instance = axios.create({

            baseURL: paymentAssoPendingDet,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
			setResult(response.data.data)           
            setLoader(false)

			console.log("datasssssssssss =========================>", response.data.data)

          }).catch((error) =>{
            

            console.log('error',error.message)
            
          });


    }


    let sl=1;

    let newarr =0;
    let uparr =0;
    let inarr =0;
    let apparr =0;

    return( 
        <div className="dashboard">
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div>

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title"> Dashboard - Officials  </h2>
                        </div>
                    </div>


                    {!loader?

                        <div class="container">


                            <table class="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                        <th scope="col">Sl.No</th>
                                        <th scope="col">Association Name</th>
                                        <th scope="col">New Officials</th>
                                        <th scope="col">Check Pending</th>
                                        <th scope="col" style={{textAlign:'center'}}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="rules-table-content">
                                {
									result?.map((item,index) =>(
                                        
                                        
                                        <tr >
                                            <td>{sl++}</td>
											<td>{decode(item.asso_name)}</td>
                                            <td>
                                                <Link  to={"/new_officials/"+item.asso_id} style={{color:'#000'}} data-toggle="tooltip" title="New Officials">
                                                {item.createdCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.createdCount}
                                                </Link>
                                            </td>
                                            <td>
                                                <Link  to={"/official/pending/"+item.asso_name+"/"+item.asso_id} style={{color:'#000'}} data-toggle="tooltip" title="Check Pending Officials">
                                                {item.checkPending=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.checkPending}
                                                </Link>
                                            </td>
                                            <td>
                                                <div className="list-action-wrpr showicons roundicons-text">
                                                    <div className="list-action-wrpr">
                                                        <Link  to={"/officials/"+item.asso_id} data-toggle="tooltip" title="View">
                                                            <i class="view icon-eye"></i>
                                                            <span>View All</span>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </td>
                                        
                                        </tr>
                                    ))
                                }
                                
                                </tbody>
                            </table>
                        </div>:

                        
                    <div class="container" style={{alignItems:'center', marginLeft:'45%', marginTop:'20%'}}>
                    <div className="fp-container">
                        <FallingLines
                            color="#fff"
                            width="50"
                            visible={true}
                            ariaLabel='falling-lines-loading'
                            />
                    </div>
                    </div>

                    }            

                    </div>
                </div>
            </aside>
        </div>
    )
};

export default AssociationMoreDashboard;
